module.exports = __webpack_public_path__ + "static/img/3en.4e65712.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/yijia/3en.png
// module id = xVxI
// module chunks = 0